import setContent from './set-content';

const asyncThunks = {
  setContent,
};

export default asyncThunks;
